/**
 * @file Feature Slider
 */

import KeenSlider from 'keen-slider';

/**
 * Feature Slider component
 */
const vFeatureSlider = () => {
	const featureSlider = document.querySelector( '.v-feature-slider' );

	if ( ! featureSlider ) {
		return;
	}

	const gallery = featureSlider.querySelector( '.v-feature-slider__slides' );
	const dots    = featureSlider.querySelectorAll( '.v-feature-slider__dot' );

	gallery.classList.add( 'v-feature-slider__slides--loaded' );
	new KeenSlider(
		gallery,
		{
			loop:     true,
			drag:     true,
			selector: '.v-feature-slider__slide',
			slides:   {
				perView: 'auto',
				origin:  'center',
			},
			defaultAnimation: {
				duration: 750,
			},
			breakpoints: {
				'(max-width: 1240px)': {
					disabled: true,
				},
			},
		},
		[
			( slider ) => {
				slider.on( 'created', () => {
					dots.forEach( ( dot ) => {
						const { index } = dot.dataset;
						dot.addEventListener( 'click', () => {
							slider.moveToIdx( parseInt( index, 10 ) );
						} );
					} );
				} );

				slider.on( 'slideChanged', () => {
					[ ...dots ].forEach( ( dot ) => {
						dot.classList.remove( 'v-feature-slider__dot--active' );
					} );

					dots[ slider.track.details.rel ].classList.add( 'v-feature-slider__dot--active' );
				} );
			},
		],
	);
};

export default vFeatureSlider;
